import template from './managerAsEmployeeCalendarMobile.html';
import controller from './managerAsEmployeeCalendarMobile.controller';

let managerAsEmployeeCalendarMobileComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default managerAsEmployeeCalendarMobileComponent;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/managerAsEmployeeCalendarMobile/managerAsEmployeeCalendarMobile.component.js